import { render, staticRenderFns } from "./CodeForm.vue?vue&type=template&id=4a975b32&scoped=true"
import script from "./CodeForm.vue?vue&type=script&lang=js"
export * from "./CodeForm.vue?vue&type=script&lang=js"
import style0 from "./CodeForm.vue?vue&type=style&index=0&id=4a975b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a975b32",
  null
  
)

export default component.exports